<template>
<div class="backgroud-white cs-courseSchedule-editor" v-loading="isLoadingData">
    <div class="backgroud-gray-popup popup-content-area-small">
        <el-row class="refund-detail-area">
            <el-col :span="4">
                <span>课程名称：</span>
            </el-col>
            <el-col :span="6">
                <span>{{refundDetailModel.CourseName}}</span>
            </el-col>
        </el-row>
         <el-row class="refund-detail-area">
            <el-col :span="4">
                <span>选择优惠：</span>
            </el-col>
            <el-col :span="6">
                <span>{{refundDetailModel.SelectedDiscount }}</span>
            </el-col>
        </el-row>
        <el-row class="refund-detail-area">
            <el-col :span="4">
                <span>实收价格：</span>
            </el-col>
            <el-col :span="6">
                <span>{{refundDetailModel.PaymentDiscountPrice | toCurrency}}</span>
            </el-col>
        </el-row>
        <el-row class="refund-detail-area" v-if="refundDetailModel.HasRelatedWorkflow">
            <el-col :span="4">
                <span>课程连报差价：</span>
            </el-col>
            <el-col :span="6">
                <span>{{refundDetailModel.WorkflowRelatedDicountAmount | toCurrency}}</span>
            </el-col>
        </el-row>
        <el-row class="refund-detail-area">
            <el-col :span="3">
                <span>支付方式：</span>
            </el-col>
            <el-col :span="5">
                <div>现金/转帐</div>
                <div>{{refundDetailModel.IncomeInFact| toCurrency}}</div>
            </el-col>
            <el-col :span="5">
                <div>旧余额</div>
                <div>{{refundDetailModel.OldBalanceCost| toCurrency}}</div>
            </el-col>
            <el-col :span="5">
                <div>新余额</div>
                <div>{{refundDetailModel.NewBalanceCost| toCurrency}}</div>
            </el-col>
             <el-col :span="5">
                <div>赠送余额</div>
                <div>{{refundDetailModel.GiftBalanceCost| toCurrency}}</div>
            </el-col>
        </el-row>
        <el-row class="refund-detail-area margin-top-10">
            <el-col :span="3">
                &nbsp;
            </el-col>
            <el-col :span="5">
                <div>占位</div>
                <div>{{refundDetailModel.AdvanceEnrollmentCost| toCurrency}}</div>
            </el-col>
            <el-col :span="5">
                <div>积分</div>
                <div>{{refundDetailModel.BonusPointCost}}</div>
            </el-col>
            <el-col :span="5">
                <div>代金券</div>
                <div>{{refundDetailModel.CashDecreasedAmount| toCurrency}}</div>
            </el-col>
             <el-col :span="5">
                <div>优惠券</div>
                <div>{{refundDetailModel.CouponDiscountDollar| toCurrency}}</div>
            </el-col>
        </el-row>
        <el-row class="refund-detail-area" v-if="refundDetailModel.HasTax">
            <el-col :span="4">
                <span>税率：</span>
            </el-col>
            <el-col :span="6">
                <span>{{refundDetailModel.TaxRate | toPercent}}</span>
            </el-col>
        </el-row>
        <el-row class="refund-detail-area" v-if="!refundDetailModel.IsVip">
            <el-col :span="4">
                <span>激活时长：</span>
            </el-col>
            <el-col :span="6">
                <span>{{refundDetailModel.ActionvationHours}}小时</span>
            </el-col>
        </el-row>
        <el-row class="refund-detail-area">
            <el-col :span="4">
                <span>退款单价：</span>
            </el-col>
            <el-col :span="6">
                <span>{{refundDetailModel.RefundPrice}}</span>
                <span v-if="refundDetailModel.IsVip">/ 小时</span>
            </el-col>
        </el-row>
        <el-form ref="refundResult" :model="refundResult.RefundHistory" :rules="rules">
            <el-form-item prop="RefundStatus" label="退款方式：" label-width="100px" required>
                <el-select v-model="refundResult.RefundHistory.RefundStatus" placeholder="请选择" size="mini">
                    <el-option v-for="item in refundTypeList" :key="item.Id" :label="item.Name" :value="item.Id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-show="refundResult.RefundHistory.RefundStatus == 1" prop="signedInTimeLength" label="已上课时：" label-width="100px">
                <el-input-number v-if="!refundDetailModel.IsVip" :disabled="refundDetailModel.IsVip" v-model="refundResult.RefundHistory.SignedInTimeLength" 
                    @change="onSignedInTimeLengthChange" :precision="2" :step="1" :max="maxTimeLength" :min="0" size="mini"></el-input-number>
                <span v-show="!refundDetailModel.IsVip">小时
                     <span class="margin-left-10px" v-if="decreasedAmount > 0">(对应金额: {{decreasedAmount | toCurrency}})</span>
                </span>
                <span v-if="refundDetailModel.IsVip">{{refundDetailModel.VipMinutesConsumed}}分钟 
                    <span class="margin-left-10px">对应金额: {{vipMinutesConsumedCost | toCurrency}}</span>
                (根据VIP课程记录)</span>
            </el-form-item>
        </el-form>
        <el-row v-show="refundResult.RefundHistory.RefundStatus == 2" class="refund-detail-area">
            <el-col :span="4">
                <span>&nbsp; </span>
            </el-col>
            <el-col :span="21">
                <span>该学生为{{refundDetailModel.IsAuldText}}，出勤率为：{{refundDetailModel.AttendRateText}}，{{refundDetailModel.CanRefundCash?"可":"不可"}}退现金</span>
            </el-col>
        </el-row>
        <el-row v-show="refundResult.RefundHistory.RefundStatus == 1" class="refund-detail-area">
            <!--<el-col :span="4">
                <span>&nbsp; </span>
            </el-col>-->
            <el-col :span="21">
                <span>课程剩余金额：{{refundResult.LeftMoney | toCurrency}}, </span>
                <span v-if="refundDetailModel.DecreaseDebt > 0">减欠款 {{(refundDetailModel.DecreaseDebt) | toCurrency}}
                    <span v-if="refundDetailModel.HasTax">(不含税 {{refundDetailModel.DecreaseDebtTax | toCurrency}})</span>
                    ,
                </span>
                <span v-if="refundDetailModel.CashDecreasedAmount != 0">减现金减 {{(refundDetailModel.CashDecreasedAmount) | toCurrency}},</span>
                <span v-if="refundDetailModel.CouponDiscountDollar != 0">减优惠劵 {{(refundDetailModel.CouponDiscountDollar) | toCurrency}},</span>
                <span v-if="bonusPointIncrease != 0">退还积分：{{bonusPointIncrease}}({{bonusPointIncreaseAmount | toCurrency}}), </span>
                <span v-if="bonusPointDescrease != 0">扣除积分：-{{bonusPointDescrease}}</span>

                <br/>
            
                <span>退还旧余额：{{refundResult.RefundHistory.RefundOldBalance + refundResult.RefundHistory.RefundOldBalanceTax | toCurrency}}<span v-if="refundResult.RefundHistory.RefundOldBalanceTax > 0">(含退税 {{refundResult.RefundHistory.RefundOldBalanceTax| toCurrency}})</span>,</span>
                <span>退还新余额：{{refundResult.RefundHistory.RefundNewBalance + refundResult.RefundHistory.RefundNewBalanceTax | toCurrency}}<span v-if="refundResult.RefundHistory.RefundNewBalanceTax > 0">(含退税 {{refundResult.RefundHistory.RefundNewBalanceTax| toCurrency}})</span>,</span>
                <span>退还赠送余额：{{refundResult.RefundHistory.RefundGiftBalance + refundResult.RefundHistory.RefundGiftBalanceTax | toCurrency}}<span v-if="refundResult.RefundHistory.RefundGiftBalanceTax > 0">(含退税 {{refundResult.RefundHistory.RefundGiftBalanceTax| toCurrency}})</span></span>
                <span v-if="bonusPointDescreaseNotEnough != 0">(扣除积分-{{bonusPointDescreaseNotEnough}}, 对应金额：-{{bonusPointDescreaseNotEnoughPrice | toCurrency}})</span>

            </el-col>
        </el-row>
        <el-row v-show="refundDetailModel.HasVideoPackage" class="refund-detail-area">
            <el-col :span="4">
                <span>&nbsp; </span>
            </el-col>
            <el-col :span="21">
                <span>注: 该课程已买视频包，视频包将</span>
                <span class="remark">自动退款</span>
            </el-col>
        </el-row>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
        <el-row>
            <el-col :span="20" :xs="16" class="footer-left">
                <span v-if="!showError"></span>
                <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
            </el-col>
            <el-col class="footer-right" :span="4" :xs="8">
                <el-button :disabled="refundResult.RefundHistory.RefundStatus == 2 && !refundDetailModel.CanRefundCash" :loading="loading" type="primary" @click="save()">确认退款</el-button>
            </el-col>
        </el-row>
    </div>
</div>
</template>

<style lang="scss" scoped>
.refund-detail-area {
    padding-left: 18px;

    .remark {
        color: red;
        font-weight: bold;
    }
}
</style>

<script>
import {
    getRefundDetail,
    saveRefund
} from "../../service/finance.service.js"
import {
  getBonusPointMechanismByType
} from "../../service/bonusPoint.service";
import {toDecimal} from "../../config/mUtils"

export default {
    props: {
        dataIn: {
            workflowId: Number,
            workflowCourseId: Number,
            refundHistoryId: Number
        }
    },
    data() {
        return {
            bonusPointIncrease: 0,
            bonusPointIncreaseAmount: 0,
            bonusPointDescrease: 0,
            bonusPointDescreaseNotEnough: 0,//不足积分
            bonusPointDescreaseNotEnoughPrice: 0,//积分不足扣除金额
            moneyToBonusPoint:{},
            bonusPointToMoney:{},
            refundDetailModel: {},
            refundResult: {
                RefundHistory: {
                    SelectedRefundType: "",
                    SignedInTimeLength: 0
                }
            },
            decreasedAmount: 0,
            maxTimeLength: 100,
            showError: false,
            loading: false,
            isLoadingData: false,
            disabledSaveButton: false,
            errorMessage: "",
            vipMinutesConsumedCost: 0,
            refundTypeList: [{
                Id: 1,
                Name: "退余额"
            }, {
                Id: 2,
                Name: "退现金"
            }],
            rules: {}
        }
    },
    created() {
        getBonusPointMechanismByType(1).then(result => {
            if (result && result.success) {
                this.moneyToBonusPoint = result.data;
                this.loadRefundDetail();
            }
        });

        getBonusPointMechanismByType(2).then(result => {
            if (result && result.success) {
                this.bonusPointToMoney = result.data;
                this.loadRefundDetail();
            }
        });        
    },
    methods: {
        loadRefundDetail() {
            if (Object.keys(this.moneyToBonusPoint).length > 0 && Object.keys(this.bonusPointToMoney).length > 0){
                this.refundResult.WorkflowId = this.dataIn.workflowId;
                this.refundResult.RefundHistory.WorkflowCourseId = this.dataIn.workflowCourseId;
                if (this.dataIn && this.dataIn.workflowId > 0 && this.dataIn.workflowCourseId > 0) {
                    this.isLoadingData = true;
                    getRefundDetail(this.dataIn.workflowCourseId, this.dataIn.workflowId, this.dataIn.refundHistoryId).then(result => {
                        if (result && result.success) {
                            this.refundDetailModel = result.data;
                            this.maxTimeLength = this.refundDetailModel.PaymentDiscountPrice / this.refundDetailModel.RefundPrice;
                            if (this.refundDetailModel.IsVip){
                                this.refundResult.RefundHistory.SignedInTimeLength = this.refundDetailModel.VipHoursConsumed;
                                this.refundResult.RefundHistory.CourseMinutesConsumed = this.refundDetailModel.VipMinutesConsumed;
                                this.vipMinutesConsumedCost = toDecimal(this.refundDetailModel.VipHoursConsumed * this.refundDetailModel.RefundPrice, 2);
                            }else{
                                this.refundResult.RefundHistory.SignedInTimeLength = 0;
                                this.refundResult.RefundHistory.CourseMinutesConsumed = 0;
                                this.vipMinutesConsumedCost = 0;
                            }
                            this.onSignedInTimeLengthChange(this.refundResult.RefundHistory.SignedInTimeLength);
                            this.refundResult.RefundHistory.PayDebt = this.refundDetailModel.DecreaseDebt
                            if (result.data.RefundHistory) {
                                this.refundResult.RefundHistory = result.data.RefundHistory;
                                this.onSignedInTimeLengthChange(this.refundResult.RefundHistory.SignedInTimeLength); 
                            }
                        }else{
                            if (!!result.message){
                                this.$message({
                                    message: result.message,
                                    type: 'error'
                                });
                            }
                        }
                        this.isLoadingData = false;
                    });
                }
            }
        },
        save() {
            if (!this.refundResult.RefundHistory.RefundStatus){
                this.$message({
                            message: '请选择退款方式',
                            type: 'warning'
                });
                return;
            }

            if (!!this.refundDetailModel.Debt){
                this.$message({
                    message: '有欠款的账目暂不允许退款',
                    type: 'warning'
                });
                return;
            }


            let self = this;
            this.loading = true;
            this.$confirm('您确认要按此退款方案进行退款吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                self.refundResult.WorkflowId = self.dataIn.workflowId;
                self.refundResult.OriginalRefundDetail = self.refundDetailModel;
                self.refundResult.StudentId = self.refundDetailModel.StudentId;
                
                if(self.refundResult.RefundHistory.PayDebt == 0 && self.refundDetailModel.DecreaseDebt>0){
                    self.refundResult.RefundHistory.PayDebt = self.refundDetailModel.DecreaseDebt
                } 
                saveRefund(self.refundResult).then(result => {
                    if (result && result.success) {
                        this.$message({
                            message: '退款成功',
                            type: 'success'
                        });
                        self.reset();
                        self.$emit("closeRefundEditor", "success");
                    } else {
                        self.showError = true;
                        self.errorMessage = result.message;
                    }
                    self.loading = false;
                });
            }).catch(() => {
                self.loading = false;
            });
        },
        onSignedInTimeLengthChange(value) {  
            //1.减去已上课时后，课程节余金额。如是课程连报，还需减去连报差价
            this.decreasedAmount = toDecimal(value * this.refundDetailModel.RefundPrice, 2);
            this.refundResult.LeftMoney = toDecimal(this.refundDetailModel.PaymentDiscountPrice - this.decreasedAmount 
                - this.refundDetailModel.WorkflowRelatedDicountAmount, 2);
            if (this.refundResult.LeftMoney < 0){
                this.refundResult.LeftMoney = 0;
            }
            this.refundResult.RefundHistory.RefundBalance = 0;
            this.refundResult.RefundHistory.RefundOldBalance = 0;
            this.refundResult.RefundHistory.RefundNewBalance = 0;
            this.refundResult.RefundHistory.RefundGiftBalance = this.refundDetailModel.GiftBalanceCost;


            this.refundResult.RefundHistory.RefundBonusPointDecreased = 0;

            this.bonusPointIncrease = 0;
            this.bonusPointDescrease = 0;
            this.bonusPointDescreaseNotEnough = 0;
            this.bonusPointDescreaseNotEnoughPrice = 0;
            let afterCashDecrease = this.refundResult.LeftMoney - this.refundDetailModel.CashDecreasedAmount - this.refundDetailModel.CouponDiscountDollar - this.refundDetailModel.GiftBalanceCost;
            if (this.refundDetailModel.DecreaseDebt > 0){
                afterCashDecrease -= this.refundDetailModel.DecreaseDebt;
            }
            
            //2.减去现金减后，课程节余金额。如果<=0，那么无钱可退；如果>0，那么开始处理积分
            if (afterCashDecrease <= 0) {
                this.refundResult.RefundHistory.RefundBonusPoint = 0;
                this.refundResult.RefundHistory.RefundBalance = 0;
                let refundGiftBalance = this.refundResult.LeftMoney - this.refundDetailModel.CashDecreasedAmount - this.refundDetailModel.CouponDiscountDollar;
                if (refundGiftBalance > 0){
                    if (refundGiftBalance > this.refundDetailModel.GiftBalanceCost){
                        refundGiftBalance = this.refundDetailModel.GiftBalanceCost;
                    }
                }else{
                    refundGiftBalance = 0;
                }
                this.refundResult.RefundHistory.RefundGiftBalance = refundGiftBalance;
            } else {
                //3.减去积分抵扣后，课程节余金额。如果<=0，那么说明积分可以抵扣完节余金额，则退还节余金额对应的积分；如果>0，那么退还所有积分，且开始处理余额
                let afterBonusPointDecrease = afterCashDecrease - this.refundDetailModel.BonusPointAmount;
                if (afterBonusPointDecrease <= 0) {
                    this.refundResult.RefundHistory.RefundBonusPoint = Math.round(this.refundDetailModel.BonusPointCost * (afterCashDecrease / this.refundDetailModel.BonusPointAmount));
                    this.refundResult.RefundHistory.RefundBalance = 0;
                    this.bonusPointIncrease =  this.refundResult.RefundHistory.RefundBonusPoint;
                    this.bonusPointIncreaseAmount = this.getBonusPointAmount(this.bonusPointIncrease);
                    this.bonusPointDescrease = 0;
                } else {
                    this.refundResult.RefundHistory.RefundBonusPoint = this.refundDetailModel.BonusPointCost;
                    this.bonusPointIncrease =  this.refundResult.RefundHistory.RefundBonusPoint;
                    this.bonusPointIncreaseAmount = this.getBonusPointAmount(this.bonusPointIncrease);
                    this.bonusPointDescrease = 0;
                    //4.实付金额=现金/转帐+余额支付+占位支付, 如果实付金额<=课程节余金额,那么最多只能退实付金额到余额；否则退课程节余金额到余额。
                    let paidSum = this.refundDetailModel.IncomeInFact + this.refundDetailModel.BalanceCost + this.refundDetailModel.AdvanceEnrollmentCost;
                    if (paidSum > 0){
                        this.refundResult.RefundHistory.RefundBalance = paidSum <= afterBonusPointDecrease ? paidSum : afterBonusPointDecrease;
                        //5.如果要退余额，计算应退的新余额和旧余额
                        if (this.refundDetailModel.OldBalanceCost >= this.refundResult.RefundHistory.RefundBalance){
                            this.refundResult.RefundHistory.RefundNewBalance = 0;
                            this.refundResult.RefundHistory.RefundOldBalance = this.refundResult.RefundHistory.RefundBalance;
                        }else{
                            this.refundResult.RefundHistory.RefundOldBalance = this.refundDetailModel.OldBalanceCost;
                            this.refundResult.RefundHistory.RefundNewBalance = this.refundResult.RefundHistory.RefundBalance - this.refundResult.RefundHistory.RefundOldBalance;
                            //6. 如果要退新余额，扣除对应积分
                            if (this.refundDetailModel.IsDecreaseBonusPoint){
                                let bonusPointValue = this.refundResult.RefundHistory.RefundNewBalance * this.moneyToBonusPoint.BonusPoint / this.moneyToBonusPoint.Money;
                                let bonusPoint = parseInt(bonusPointValue);
                                
                                if (this.refundDetailModel.CourseBonusPointRate != 1){
                                    bonusPoint = parseInt(bonusPointValue * this.refundDetailModel.CourseBonusPointRate);
                                }

                                this.bonusPointDescrease = bonusPoint;
                                let totalRefundBonusPoint =  this.refundResult.RefundHistory.RefundBonusPoint - bonusPoint;
                                //判断学生积分是否足够，如果积分不足，扣除余额
                                let studentBonusPoint = parseInt(this.refundDetailModel.StudentBonusPoint);
                                if (totalRefundBonusPoint < 0 && studentBonusPoint + totalRefundBonusPoint < 0){  
                                    
                                    let bonusPointDiff = (studentBonusPoint + totalRefundBonusPoint) * -1;  
                                    //忽略误差  
                                    if (bonusPointDiff=== 1){
                                        bonusPointDiff = 0;
                                    }        
                                    totalRefundBonusPoint = studentBonusPoint * -1;
                                    this.bonusPointDescrease = studentBonusPoint + this.bonusPointIncrease;
                                    let balance = bonusPointDiff * this.bonusPointToMoney.Money / this.bonusPointToMoney.BonusPoint;
                                    this.bonusPointDescreaseNotEnough = bonusPointDiff;
                                    this.bonusPointDescreaseNotEnoughPrice = balance;

                                    this.refundResult.RefundHistory.RefundBonusPointNotEnough = bonusPointDiff;
                                    this.refundResult.RefundHistory.RefundBonusPointNotEnoughAmount = balance;

                                    this.refundResult.RefundHistory.RefundNewBalance -= balance;
                                    if (this.refundResult.RefundHistory.RefundNewBalance < 0){
                                        this.refundResult.RefundHistory.RefundOldBalance += this.refundResult.RefundHistory.RefundNewBalance;
                                        this.refundResult.RefundHistory.RefundNewBalance = 0;
                                        if (this.refundResult.RefundHistory.RefundOldBalance < 0){
                                            this.refundResult.RefundHistory.RefundOldBalance = 0;
                                        }
                                    }
                                    this.refundResult.RefundHistory.RefundBalance = this.refundResult.RefundHistory.RefundOldBalance + this.refundResult.RefundHistory.RefundNewBalance;
                                }
                                this.refundResult.RefundHistory.RefundBonusPointDecreased = this.bonusPointDescrease * -1;
                            }
                        }
                    }
                    else{
                        this.refundResult.RefundHistory.RefundBalance = 0;
                    }
                }
            }

            if (this.refundDetailModel.HasTax){
                this.refundResult.RefundHistory.RefundOldBalanceTax =this.refundResult.RefundHistory.RefundOldBalance * this.refundDetailModel.TaxRate;
                this.refundResult.RefundHistory.RefundNewBalanceTax = this.refundResult.RefundHistory.RefundNewBalance * this.refundDetailModel.TaxRate;
                this.refundResult.RefundHistory.RefundGiftBalanceTax = this.refundResult.RefundHistory.RefundGiftBalance * this.refundDetailModel.TaxRate;
            }else{
                this.refundResult.RefundHistory.RefundOldBalanceTax = 0;
                this.refundResult.RefundHistory.RefundNewBalanceTax = 0;
                this.refundResult.RefundHistory.RefundGiftBalanceTax = 0;
            }
        },
        reset() {
            this.showError = false;
            this.errorMessage = '';
            this.refundResult.RefundHistory.SelectedRefundType = "";
            this.refundResult.RefundHistory.SignedInTimeLength = 0;
            this.$refs["refundResult"].resetFields();
        },
        getBonusPointAmount(value){
            return toDecimal(value * this.bonusPointToMoney.Money /
                this.bonusPointToMoney.BonusPoint);               
        },
    },
    watch: {
        dataIn: function () {
            this.loadRefundDetail();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/refundEditor.vue